import { addCarPreData, setDataPreOption, initPreOption } from '@/mapTools'

const state = {
  // 0开始 1初始化完成 2 option设置完成 -1 离开页面
  chat_pre_status: 0,
  map_oil: [],
  all_map_oil: [],
  map_station: [],
  all_map_station: [],
  map_one_route: [],
  all_map_one_route: [],
  active_station: ''
}

const getters = {
  mapOil: state => state.map_oil,
  activeStation: state => state.active_station,
  mapStation: state => state.map_station,
  mapOneRoute: state => state.map_one_route,
  allMapOil: state => state.all_map_oil,
  allMapStation: state => state.all_map_station,
  allMapOneRoute: state => state.all_map_one_route
}

const actions = {
  setMapPreCenter ({ commit }, data) {
    // 设置地图中心点
    let option = window.myPreChat.getOption()
    option.bmap[0].center = data.center
    option.bmap[0].zoom = data.zoom
    window.myPreChat.setOption(option, true)
  },
  initMapPreOption ({ commit, getters, dispatch }) {
    // 初始化地图配置
    window.myPreChat.clear()
    window.myPreChat.setOption(initPreOption(), true)
    dispatch('setChatPreStatus', 2)
  },
  setChatPreStatus ({ commit }, data) {
    // 设置地图状态
    commit('changeChatPreStatus', data)
  },
  selectMapOil ({ commit, getters, dispatch }, data) {
    //
    let allData = getters.allMapOil
    if (!data) {
      dispatch('setMapOil', allData)
      return
    }
    let newData = []
    let oilData = getters.gasLocation
    allData.forEach(function (item) {
      if (oilData[item.name][2] === data) {
        newData.push(item)
      }
    })
    let newData2 = []
    if (getters.mapOneRoute.length > 0) {
      newData.forEach(function (item) {
        getters.mapOneRoute.forEach(function (item2) {
          if (item2.data[0].toName === item.name) {
            newData2.push(item)
          }
        })
      })
    } else {
      newData2 = newData
    }
    dispatch('setMapOil', newData2)
  },
  selectMapStation ({ commit, getters, dispatch }, data) {
    // 选择地图上的油库
    let allData = getters.allMapStation
    if (!data) {
      dispatch('setMapStation', allData)
      return
    }
    let newData = []
    allData.forEach(function (item) {
      if (item.name === data) {
        newData.push(item)
      }
    })
    dispatch('setMapStation', newData)
  },
  selectMapOneRoute ({ commit, getters, dispatch }, data) {
    let allData = getters.allMapOneRoute
    if (!data) {
      dispatch('setMapOneRoute', allData)
      return
    }
    let newData = []
    allData.forEach(function (item) {
      if (item.data[0].fromName === data) {
        newData.push(item)
      }
    })
    dispatch('setMapOneRoute', newData)
  },
  setMapOil ({ commit }, data) {
    commit('changeMapOil', data)
  },
  setMapStation ({ commit }, data) {
    commit('changeMapStation', data)
  },
  setMapOneRoute ({ commit }, data) {
    commit('changeMapOneRoute', data)
  },
  setAllMapOil ({ commit, dispatch, getters }, data) {
    commit('changeAllMapOil', data)
    dispatch('selectMapOil', getters.activeStation)
  },
  setActiveStation ({ commit, dispatch, getters }, data) {
    // 地图上设置油库
    commit('changeActiveStation', data)
    data = data === '全部' ? '' : data
    let mapOption = getters.depotLocation[data]
    if (data && mapOption) {
      dispatch('setMapPreCenter', {center: mapOption, zoom: 12})
    }
    dispatch('selectMapOneRoute', data)
    dispatch('selectMapOil', data)
    dispatch('selectMapStation', data)
  },
  setAllMapStation ({ commit, dispatch, getters }, data) {
    commit('changeAllMapStation', data)
    dispatch('selectMapStation', getters.activeStation)
  },
  setAllMapOneRoute ({ commit, dispatch }, data) {
    commit('changeAllMapOneRoute', data)
    dispatch('selectMapOneRoute', '')
  }
}

const mutations = {
  changeChatPreStatus (state, data) {
    state.chat_pre_status = data
    if (data === 2) {
      let optionList = [{
        key: 'Location',
        data: state.map_oil
      },
      {
        key: 'centroids',
        data: state.map_station
      }]
      optionList.forEach(function (item) {
        setDataPreOption(item.key, item.data)
      })
      addCarPreData(window.myPreChat, state.map_one_route)
    }
  },
  changeActiveStation (state, data) {
    state.active_station = data
  },
  changeMapOil (state, data) {
    if (state.chat_pre_status === 2) {
      setDataPreOption('Location', data)
    }
    state.map_oil = data
  },
  changeMapStation (state, data) {
    if (state.chat_pre_status === 2) {
      setDataPreOption('centroids', data)
    }
    state.map_station = data
  },
  changeMapOneRoute (state, data) {
    if (state.chat_pre_status === 2) {
      let option = window.myPreChat.getOption()
      option.series = option.series.slice(0, 2)
      window.myPreChat.setOption(option, true)
      addCarPreData(window.myPreChat, data)
    }
    state.map_one_route = data
  },
  changeAllMapOil (state, data) {
    state.all_map_oil = data
  },
  changeAllMapStation (state, data) {
    state.all_map_station = data
  },
  changeAllMapOneRoute (state, data) {
    state.all_map_one_route = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/db_pre_map.js